import { datadogRum } from '@datadog/browser-rum'
import { config } from '../config'

export const setupDataDog = host => {
  try {
    datadogRum.init({
      applicationId: config?.datadog?.applicationId || '262dfcc8-b8a1-40d9-b10b-c402b79ab5b8',
      clientToken: config.datadog.clientToken || 'pub5b3c7ab1276b3e359f31e3e579fa1dc8',
      service: config.datadog.service || 'spindle-ui',
      env: config.datadog?.env || 'dev',
      sampleRate: Number(config.datadog?.sampleRate) || 100,
      trackInteractions: true,
    })
    datadogRum.startSessionReplayRecording()
  } catch (e) {
    console.error('Datadog init failed')
  }
}
